var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import { Links } from '../../components/links';
import { ReactIntl, InitIntl } from '../../helpers/intel';
import useClasses from './modal.style';
const UpdatePaymentModal = ({ isOpen, onClose, currentLanguage }) => {
    const sx = useClasses();
    const [intl, setIntl] = useState(InitIntl());
    const fetchIntel = useCallback((lng) => __awaiter(void 0, void 0, void 0, function* () {
        setIntl(yield ReactIntl(lng || 'en', 'update-payment-modal'));
    }), []);
    useEffect(() => {
        fetchIntel(currentLanguage);
    }, [currentLanguage]);
    return (React.createElement(Dialog, { open: isOpen, onClose: onClose, className: sx.modal },
        React.createElement(Box, { className: sx.content },
            React.createElement(Box, { className: sx.logoWrapper },
                React.createElement("img", { className: sx.icon, src: 'https://assets.designs.ai/icons/icon-error-red.svg' })),
            React.createElement("div", { className: sx.textWrapper },
                React.createElement(Typography, { className: sx.title }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                    id: 'error_message',
                    defaultMessage: 'We’ve encountered a problem with your payment.'
                })),
                React.createElement(Typography, { className: sx.description }, intl === null || intl === void 0 ? void 0 :
                    intl.formatMessage({
                        id: 'error_desc1',
                        defaultMessage: 'Please update your payment method to continue.'
                    }),
                    React.createElement("br", null), intl === null || intl === void 0 ? void 0 :
                    intl.formatMessage({
                        id: 'error_desc2',
                        defaultMessage: 'Thank you for your cooperation.'
                    }))),
            React.createElement(Box, { className: sx.buttonWrapper },
                React.createElement(Links, { to: '/user/account/settings?tab=payment_details' },
                    React.createElement(Button, { variant: 'contained', onClick: onClose }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                        id: 'btn_update',
                        defaultMessage: 'Update payment details'
                    }))),
                React.createElement(Button, { variant: 'text', onClick: onClose }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                    id: 'btn_cancel',
                    defaultMessage: `I'll do it later`
                }))))));
};
export default UpdatePaymentModal;
//# sourceMappingURL=index.js.map